export default __webpack_public_path__ + "static/media/RobotoMono-ExtraLight.1fdc6da0.woff2";